export const getNavbarSubpageHref = (page, subpage) => {
    const anchorId = subpage.anchorId?.trim();
    return `/${page.path}/${subpage.path}${anchorId ? `#${encodeURIComponent(anchorId)}` : ''}`;
};
